<div>
  <p data-test="body-help-text" class="iris-mb-05">
    {{config.bodyHelpText}}
  </p>

  <div class="alert">
    <mat-icon>info</mat-icon>
    <p>{{config.alertText}}</p>
  </div>
</div>